<template>
  <div class="index-footer-page">
    <div class="footer-content">
      <a-space style="margin-right: 20px; align-items: center;" direction="vertical">
        <img class="footer-content-logo" src="../../../public/static/index/index-footer.png" />
        <div class="footer-content-about" @click="$router.push('/aboutUs')">{{ $t('aboutUs') }}</div>
      </a-space>
      <a-space style="margin-right: 20px; width: 450px; " direction="vertical" :size="8">
        <span>{{ $t('indexFooterAddress') }}</span>
        <span>{{ $t('indexFooterPhone') }}</span>
        <span>{{ $t('indexFooterEmail') }}</span>
      </a-space>
      <a-space direction="vertical" :size="16">
<!--        <span>{{ $t('footerRightTop') }}</span>-->
        <span>
            <span>Copyright  {{ $moment().format('YYYY') }} </span>
            <a href="https://beian.miit.gov.cn/" target="_blank">{{ $t('copyright') }}</a>
<!--            <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502019290">< img src="../../../public/static/image/beian.png" style="margin: 0 5px;" />沪公网安备 31011502019290号</ a>-->
        </span>
      </a-space>
      <a-space direction="vertical" style="align-items: center;">
        <span>{{ $t('logoTitle') }}</span>
        <img height="84" width="84" src="../../../public/static/index/weChat.jpg" />
<!--        <img v-else height="84" width="84" :src="imgUrl" />-->
      </a-space>

    </div>
  </div>
</template>

<script>
export default {
  name: "index-footer",
  data(){
    return{
      imgUrl: ''
    }
  },
  methods:{

  },
  created() {
    /*let condition = {
      SYS_TYPE: 20011001,
      TARGET_CATE: 20021014,
      TARGET_TYPE: 20071001,
      TARGET_ID: this.$store.state?.userInfo?.COMPANY_ID,
      GUID_CODE: ''
    }
    this.$h5Api({
      type: '2021',
      data: [condition],
    }).then(({data}) => {
      this.imgUrl = this.$Dolphin.path.filePath + data?.FILE_LIST?.[0]?.FILE_NAME;
    })*/
  }
}
</script>

<style lang="scss">
.index-footer-page{
  width: 100%;
  background: #113A64;

  .footer-content{
    width: 1200px;
    height: 148px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #FFFFFF;
    font-size: 12px;
    font-weight: 400;

    .footer-content-logo{
      width: 186px;
    }
    .footer-content-about{
      margin-top: 20px;
      padding: 6px 64px;
      border-radius: 4px;
      border: 1px solid #4D6D8F;
      text-align: center;
      cursor: pointer;
    }
  }
}

</style>